import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';

const useDeleteEventDate = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const deleteEventDate = async ({
    dateId,
    eventId,
    causeId,
  }: {
    dateId: string;
    eventId: string;
    causeId: string;
  }) => {
    const { data } = await StoreApi.delete(
      `/store_items/${eventId}/event_dates/${dateId}?cause_id=${causeId}`
    );
    return data;
  };

  return useMutation({
    mutationFn: deleteEventDate,
    onSuccess(_, variables) {
      const { causeId, eventId } = variables;
      void queryClient.invalidateQueries({
        queryKey: storeKeys.id(causeId).items.events.id(eventId).dates.all,
      });
    },
  });
};

export { useDeleteEventDate };
